import React from 'react'
import { BillboardButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ControlHighlight } from '@fs/zion-icon'
import { useFamilyReviewDispatchContext } from '../../providers/FamilyReviewContext'

export default function HighlightButton({ isAdding, handleHighlightButtonClicked, editHighlightsOverlay, id }) {
  const [t] = useTranslation()
  const dispatch = useFamilyReviewDispatchContext()
  return (
    <BillboardButton
      data-testid="highlight-button"
      Icon={ControlHighlight}
      iconSize="xs"
      emphasis="low"
      linkName={isAdding ? 'Add Highlight' : 'Edit Highlight'}
      onClick={() => {
        dispatch({
          type: 'SET_IS_ADDING_HIGHLIGHT',
          value: isAdding,
        })
        editHighlightsOverlay.open()
        handleHighlightButtonClicked(id)
      }}
    >
      {isAdding
        ? t('edit-index.add-highlight.button', 'Add Highlight')
        : t('edit-index.edit-highlight.button', 'Edit Highlight')}
    </BillboardButton>
  )
}
